import React, { useState, useEffect } from 'react'
import { Modal, Dropdown, Alert } from 'rsuite'
// import { ModalTitle, AddToEventButton, BackButton, SelectionTitle } from '../Activity/ActivityStyledComponents'
import { ModalTitle, AddToEventButton, SelectionTitle } from '../Activity/ActivityStyledComponents'
import styled from 'styled-components'
import { colors } from '../Styles/common-styles'
import { getAllEvents, updateEvent } from '../../Context/firebase'
import { SuccessfullyAddedIcon } from '../Icons'
import { v4 } from 'uuid'

/* ALL COMMENTS ARE NECESSARY FOR FUTURE ADDITIONS */
const CustomDropdown = styled(Dropdown)`
    margin-top: 12px;
    .rs-dropdown-toggle, .rs-dropdown-toggle.rs-btn {
        width: 100%;
    },
    .rs-dropdown-menu {
        width: 100%;
        text-align: left;
    },
    .rs-btn, .rs-btn-subtle, .rs-dropdown-toggle {
        color: ${colors.black};
        text-align: left;
    },
    .rs-dropdown-menu > .rs-dropdown-item > .rs-dropdown-item-content:hover, .rs-dropdown-menu > .rs-dropdown-item > .rs-dropdown-item-content:focus {
        text-decoration: none;
        color: #575757;
        background-color: ${colors.highlighter};
    }
}
`

const AddToEventModal = ({ activityName, activity }) => {
  // const [chooseExistingEvent, setChooseExistingEvent] = useState(false)
  const [events, setEvents] = useState()
  const [selectedEvent, setSelectedEvent] = useState()
  const [selectedEventData, setSelectedEventData] = useState()
  const [selectedPhase, setSelectedPhase] = useState()
  const [isReqSuccessful, setReqSuccessful] = useState(false)

  useEffect(() => {
    getAllEvents().then(setEvents)
  }, [])

  useEffect(() => {
    if (events) {
      events.forEach(item => {
        if (item.title === selectedEvent) {
          setSelectedEventData(item)
        }
      })
    }
  }, [selectedEvent])

  const onAddToExistingEvent = () => {
    if (!selectedEvent || !selectedPhase) {
      return Alert.error('Please select both event and phase')
    } else {
      const eventId = selectedEventData.id
      activity.id = v4()
      selectedEventData.phases[selectedPhase.id].data.push(activity)
      updateEvent(eventId, selectedEventData)
        // .then(())
        .then(() => setReqSuccessful(true))
    }
  }
  /* ALL COMMENTS ARE NECESSARY FOR FUTURE ADDITIONS */

  // const CreateNewOrAddToExisting = () => (
  //   <>
  //     <Modal.Header />
  //     <Modal.Body>
  //       <ModalTitle>Add '{activityName}' activity to: </ModalTitle>
  //     </Modal.Body>
  //     <Modal.Footer>
  //       <div style={{ display: 'flex', justifyContent: 'space-between' }}>
  //         <AddToEventButton
  //           reverse
  //           onClick={() => setChooseExistingEvent(true)}
  //         > Existing event
  //         </AddToEventButton>
  //         <AddToEventButton reverse disabled>Create new event </AddToEventButton>
  //       </div>
  //     </Modal.Footer>
  //   </>
  // )

  const AddToExistingEvent = () => (
    <>
      <Modal.Header>
        <Modal.Title>
          {/* <BackButton
            onClick={() => {
              // setChooseExistingEvent(false)
              setSelectedEvent('')
              setSelectedPhase('')
            }}
          > &#8592; Back</BackButton> */}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ height: '400px' }}>
        <ModalTitle>Add '{activityName}' activity to: </ModalTitle>
        <div style={{ display: 'flex', flexDirection: 'column', marginTop: '10px' }}>
          <SelectionTitle>One of your events</SelectionTitle>
          <CustomDropdown title={selectedEvent || 'Select event'}>
            {events &&
                    events.map((item, index) => (
                      <Dropdown.Item
                        key={index}
                        onSelect={value => {
                          if (value !== selectedEvent) {
                            setSelectedEvent(value)
                            setSelectedPhase('')
                          }
                        }}
                        eventKey={item.title}
                      >
                        {item.title}
                      </Dropdown.Item>
                    ))}
          </CustomDropdown>

          {selectedEventData &&
            <>
              <SelectionTitle>Phase in this event</SelectionTitle>
              <CustomDropdown title={selectedPhase.name || 'Select phase'}>
                {selectedEventData?.phases.map((item, index) => (
                  <Dropdown.Item
                    key={index}
                    onSelect={value => setSelectedPhase({ id: index, name: value })}
                    eventKey={item.name}
                  >
                    {item.name}
                  </Dropdown.Item>
                ))}
              </CustomDropdown>
            </>}

        </div>
      </Modal.Body>
      <Modal.Footer style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <AddToEventButton onClick={onAddToExistingEvent}>Add </AddToEventButton>
      </Modal.Footer>
    </>
  )

  const SuccessfullyAdded = () => (
    <>
      <Modal.Header />
      <Modal.Body style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <SuccessfullyAddedIcon />
        <ModalTitle style={{ marginTop: '23px' }}>Successfully added!</ModalTitle>
      </Modal.Body>
      <Modal.Footer style={{ textAlign: 'center', marginBottom: '34px' }}>
        <SelectionTitle>'{activityName}' activity has been added to '{selectedPhase.name}' phase of '{selectedEvent}' event.</SelectionTitle>
      </Modal.Footer>
    </>
  )

  return (
    <div style={{ width: '500px' }}>
      {/* {chooseExistingEvent */}
      {/* ? isReqSuccessful */}
      {isReqSuccessful
        ? <SuccessfullyAdded />
        : <AddToExistingEvent />}
      {/* // : <CreateNewOrAddToExisting />} */}
    </div>
  )
}

export default AddToEventModal
